import { z } from 'zod'
import { assetSchema } from './asset'
import { batchSchema } from './batch'
import { chargeSchema } from './charge'
import { listingSchema } from './listing'
import { orderSchema } from './order'
import { mediaItemSchema } from '@/api/resources/shared/media'
import { actionRequiredSchema } from './order'

export const actionTypeEnum = z.enum([
  'purchase', // 1
  'transfer', // 3
  'transferbatch', // 4
  'redeem', // 5
  'purchaseaccount', // 6
  'createaccount', // 7
  'onboardpromo', // 8
  'fundwallet', // 9
  'withdrawwallet', // 10
  'mktsale', // 11
  'mktpurchase', // 12
  'arcadeconvert' // 13
])
export const depositTypeEnum = z.enum(['crypto_transfer', 'card'])

export const userAssetSchema = assetSchema.extend({
  price: z.number().nullable().optional()
})

const transactionChainStatusSchema = z.enum(['pending', 'completed', 'failed'])

export const actionSchema = z.object({
  id: z.number(),
  type: actionTypeEnum,
  info: z.string(),
  amount: z.number().optional(),
  info_count: z.number(),
  time_created: z.string(),
  tx_chain_status: transactionChainStatusSchema.optional(),
  action_required: actionRequiredSchema.nullable()
})

const activityOrderSchema = orderSchema.extend({
  addon_amount: z.number().optional(),
  addon_count: z.number().optional()
})

const actionListingPaymentSourceSchema = z.enum(['circle', 'solana']).nullable()

const arcadeConvertedItemSchema = z.object({
  chain_asset_id: z.number(),
  points: z.number(),
  rarity: z.string(),
  name: z.string(),
  mint_num: z.number(),
  data_id: z.number(),
  cardid: z.number(),
  drop_id: z.number(),
  drop_name: z.string(),
  mints: z.array(z.number()),
  media: z.record(mediaItemSchema)
})

const arcadeConvertedItemsSchema = z.object({
  count: z.number(),
  points: z.number(),
  assets: z.record(arcadeConvertedItemSchema),
  asset_ids: z.array(z.number()),
  season_id: z.number(),
  tx_urls: z.array(z.string().url())
})

export type ArcadeConvertedItem = z.infer<typeof arcadeConvertedItemSchema>
export type ArcadeConvertedItems = z.infer<typeof arcadeConvertedItemsSchema>

export const actionDetailSchema = z.object({
  id: z.number(),
  item_id: z.number().optional().nullable(),
  type: actionTypeEnum,
  batches: z.array(batchSchema).optional(),
  charge: chargeSchema.optional(),
  tx_chain_status: transactionChainStatusSchema.optional(),
  detail: z
    .object({
      method: depositTypeEnum.optional(),
      status: z.string(),
      transaction_id: z.number().optional(),
      to_address: z.string().optional(),
      network: z.string(),
      token: z.string(),
      amount: z.number(),
      total_amount: z.number(),
      tx_url: z.string().optional(),
      merchant: z.string().optional(),
      payment_method: z.string().optional(),
      fees: z.number().optional()
    })
    .optional(),
  listing: listingSchema
    .extend({
      reservation_id: z.string().nullable(),
      payment_source: actionListingPaymentSourceSchema
    })
    .optional(),
  info: z.string(),
  amount: z.number().optional(),
  time_created: z.string(),
  info_count: z.number(),
  assets: z.array(userAssetSchema).optional(),
  order: activityOrderSchema.optional(),
  data: z.union([arcadeConvertedItemsSchema, z.any()])
})

export type ActionType = z.infer<typeof actionSchema>
export type TransactionChainStatus = z.infer<
  typeof transactionChainStatusSchema
>
export type ActionDetailType = z.infer<typeof actionDetailSchema>
export type ActionListingPaymentSource = z.infer<
  typeof actionListingPaymentSourceSchema
>
